var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"timeSelector",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"timeSelector__text"},[_vm._v(_vm._s(_vm.dateString))]),_c('span',{staticClass:"timeSelector__text"},[_vm._v(_vm._s(_vm.meridiemValue)+" "+_vm._s(_vm.timeString)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }